import WbPage from ".";
import WbExpressPage from "./Express";
import WbOrdersPage from "./Orders";
import WbSuppliesTable from "./Supplies";
import WbSuppliePage from "./Supplies/Supplie";

const WbPages = {
    Parent: WbPage,
    Orders: WbOrdersPage,
    Supplies: WbSuppliesTable,
    Supplie: WbSuppliePage,
    Express: WbExpressPage,
}

export default WbPages